module.exports = __webpack_public_path__ + "static/media/undraw_sunlight_re_0usx.6b2c04d5.svg";